import { Textarea } from './text-area';
import type { TextareaProps } from './type';

import { FormControl, FormItem, FormMessage } from '../form';
import type { FormLabelProps } from '../types';

export const FormTextarea = ({ formItemClassName, ...props }: TextareaProps & FormLabelProps) => (
  <FormItem className={formItemClassName}>
    <FormControl>
      <Textarea {...props} />
    </FormControl>
    <FormMessage />
  </FormItem>
);
